// src/validation/financeiroPeriodoSchema.ts
import { z } from 'zod';

// Validação de UX: o servidor valida a mesma regra (`validarPeriodo`, B-6) e continua sendo a
// autoridade; este schema só evita a viagem de rede e dá mensagem imediata. A comparação
// lexicográfica de strings `YYYY-MM-DD` é equivalente à cronológica — e evita construir `Date`,
// que reintroduziria fuso.
export const financeiroPeriodoSchema = z
  .object({
    inicio: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inicial inválida'),
    fim: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data final inválida'),
  })
  .refine((v) => v.inicio <= v.fim, {
    message: 'A data final não pode ser anterior à inicial',
    path: ['fim'],
  });

export type FinanceiroPeriodoInput = z.infer<typeof financeiroPeriodoSchema>;
